import React from "react"
import BlockHero from "@components/common/blockHero"
import ChangePageBtn from "@components/common/changePageBtn"
import BlockActuacion from "@components/common/blockActuacion"

import Cuidamos from "@images/actuacion/cuidamos.png"
import Desarrollamos from "@images/actuacion/desarrollamos.png"
import Gestionamos from "@images/actuacion/gestionamos.png"
import Anticipamos from "@images/actuacion/anticipamos.png"
import Impulsamos from "@images/actuacion/impulsamos.png"
import Actuamos from "@images/actuacion/actuamos.png"
import Contribuimos from "@images/actuacion/contribuimos.png"

const nuestraActuacion = () => {
  return (
    <div>
      <div className="element">
        <BlockHero
          title="NUESTRA ACTUACIÓN EN 2020"
          description="En un ejercicio de especial complejidad, la Entidad ha logrado mantener los niveles de calidad de servicio habituales, al tiempo que ha respondido con efectividad a las necesidades extraordinarias vinculadas con la crisis sanitaria y su impacto económico."
        />
      </div>
      <div className="margin">
        <div className="element-flex">
          <BlockActuacion
            image={Cuidamos}
            title="Cuidamos"
            subtitle="de la salud, el bienestar y la calidad de vida de las personas"
            number="15.439"
            description="consultas realizadas mediante los distintos servicios de Telemedicina"
            to="cuidamos"
            btnName="Ver más"

          />
          <BlockActuacion
            image={Desarrollamos}
            title="Desarrollamos"
            subtitle="A los profesionales más afectados"
            number="+ 1 M"
            description="de visitas mensuales a la sección de “Riesgos biológicos”"
            to="desarrollamos"
            btnName="Ver más"

          />
        </div>
        <div className="element-flex">
          <BlockActuacion
            image={Gestionamos}
            title="Gestionamos"
            subtitle="eficazmente las necesidades de los profesionales más afectados"
            number="183.700"
            description="solicitudes de profesionales autónomos para acceder a la prestación extraordinaria por cese de actividad"
            to="gestionamos"
            btnName="Ver más"

          />
          <BlockActuacion
            image={Anticipamos}
            title="Anticipamos"
            subtitle="las necesidades de futuro"
            number="91.000"
            description="presolicitudes de prestaciones para autónomos gestionadas mediante procesos de automatización RPA"
            to="anticipamos"
            btnName="Ver más"

          />
        </div>
        <div className="element-flex">
          <BlockActuacion
            image={Impulsamos}
            title="Impulsamos"
            subtitle="el desarrollo personal y profesional de nuestros empleados"
            number="1.883"
            description="empleados comprometidos con el propósito de Mutua Universal de ser socialmente responsable y contribuir a la sostenibilidad del estado del bienestar"
            to="impulsamos"
            btnName="Ver más"

          />
          <BlockActuacion
            image={Actuamos}
            title="Actuamos"
            subtitle="con transparencia y responsabilidad"
            number="+2,7 M"
            description="de impactos en comunicaciones externas con un seguimiento constante de las acciones desarrolladas para hacer frente a la pandemia y medidas de prevención"
            to="actuamos"
            btnName="Ver más"

          />
        </div>
        <div className="element-flex">
          <BlockActuacion
            image={Contribuimos}
            title="Contribuimos"
            subtitle="a un desarrollo sostenible"
            number="24"
            description="campañas e iniciativas sociales, medioambientales, solidarias y de salud durante el ejercicio 2020 con impacto en la RSC"
            to="contribuimos"
            btnName="Ver más"

          />
       <BlockActuacion
            className="hiddeElement"
            image={Contribuimos}
            title="empty"
            subtitle="empty"
            number="empty"
            description="empty"
            to="empty"
            btnName="Ver más"

          />
        </div>
      </div>

      <div className="element changePage">
        <ChangePageBtn />
      </div>
    </div>
  )
}
export default nuestraActuacion
